import { AdminsItemInfos } from "./AdminsItemInfos"

/// <summary>
/// 返回提示信息
/// </summary>
export class PromptItemInfo {

	constructor() {
		this.admins = null;
		this.keyword = null;
		this.type = -1;
	}

	static GetPromptItem(jsonItem) {
		let curItem = null;
		if (jsonItem == null) return curItem;

		curItem = new PromptItemInfo();
		curItem.keyword = jsonItem.keyword;
		curItem.admins = AdminsItemInfos.GetAdminsItems(jsonItem.admins);
		curItem.type = jsonItem.type;

		return curItem;
	}

}//end PromptItemInfo

